import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { publicImageUrl } from '../../utils/publicAsset';
import '../logistics.css';

const LogisticsHeader = ({
  text,
  lang,
  isMenuOpen,
  onToggleMenu,
  onCloseMenu,
  onLangChange,
}) => {
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const logoAlt = lang === 'ar' ? 'ترف الأولى للخدمات اللوجستية' : '1st Luxury Logistics';

  return (
    <header className="log-header">
      <div className="log-top-bar">
        <div className="log-top-bar-row">
          <Link to="/" className="log-back-link" onClick={onCloseMenu}>
            <span aria-hidden="true">‹</span>
            {lang === 'ar' ? 'رجوع' : 'Back'}
          </Link>
        </div>
      </div>

      <nav className="log-navbar">
        <div className="log-navbar__logo">
          <Link to="/logistics" className="log-logo" onClick={onCloseMenu}>
            <img src={publicImageUrl('updatedlogo.png')} alt={logoAlt} />
          </Link>
        </div>

        <button
          type="button"
          className={`log-nav-backdrop ${isMenuOpen ? 'is-visible' : ''}`}
          onClick={onCloseMenu}
          aria-label={lang === 'ar' ? 'إغلاق القائمة' : 'Close menu'}
        />

        <ul className={`log-nav-links ${isMenuOpen ? 'is-open' : ''}`}>
          <li>
            <NavLink to="/logistics" end onClick={onCloseMenu}>
              {text.navHome}
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={onCloseMenu}>
              {text.navAbout}
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" onClick={onCloseMenu}>
              {text.navServices}
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" onClick={onCloseMenu}>
              {text.navProjects}
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={onCloseMenu}>
              {text.navOrder}
            </NavLink>
          </li>
        </ul>

        <div className="log-navbar__actions">
          <button
            type="button"
            className={`log-lang-btn${lang === 'en' ? ' log-lang-btn--ar-cta' : ''}`}
            onClick={onLangChange}
            aria-label={lang === 'en' ? 'Switch to Arabic' : 'Switch to English'}
          >
            {lang === 'en' ? 'العربية' : 'English'}
          </button>
          <button
            type="button"
            className={`log-menu-toggle ${isMenuOpen ? 'is-open' : ''}`}
            onClick={onToggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>
    </header>
  );
};

export default LogisticsHeader;
